<template>
  <div>
    <label>
      {{$t('CONTENT.payments.paymentRate')}}:
      <span class="b-form__required">*</span>
    </label>
    <numeric class="b-numeric" controls :min="0" :max="1000000000000" v-model="paymentRate"></numeric>
  </div>
</template>
<script>
import ReclassSecurityPayment from "../../models/commands/ReclassSecurityPayment";

export default {
  props: {
    paymentParams: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      paymentRate: 0
    };
  },
  created() {
    this.paymentRate = 0;
  },
  methods: {
    cancel() {
      this.paymentRate = 0;
    },

    save() {
      const command = new ReclassSecurityPayment(
        this.paymentParams.idInDB,
        this.paymentRate
      );
      this.$store.commit("eventRegistryPlugin/addOrUpdateCommand", command);
      return true;
    }
  }
};
</script>

<style>
</style>
